import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './LinkWithinText.css';

const LinkWithinText = ({
  size,
  dark,
  medium,
  secondaryDark,
  secondaryLight,
  children,
  href,
  ...rest
}) => {
  const cx = classnames.bind(styles);
  const linkClasses = cx(
    'link',
    size,
    {
      dark,
      medium,
      secondaryDark,
      secondaryLight,
    }
  );
  return (
    <a className={linkClasses} href={href} {...rest}>
      {children}
    </a>
  );
};

LinkWithinText.propTypes = {
  dark: PropTypes.bool,
  medium: PropTypes.bool,
  secondaryDark: PropTypes.bool,
  secondaryLight: PropTypes.bool,
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  size: PropTypes.string
};

LinkWithinText.defaultProps = { href: '#' };

LinkWithinText.displayName = 'LinkWithinText';

export default LinkWithinText;



// WEBPACK FOOTER //
// ./src/uis/elements/Link/LinkWithinText/LinkWithinText.js